import { Box, Button, Toolbar, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/AddOutlined";
import { useLocation, useNavigate } from "react-router-dom";
import { getPageTitle } from "./navigation";
import { HeaderBreadcrumbs } from "../HeaderBreadcrumbs";
import { APPBAR_HEIGHT } from "../../styles/layout";
import { NEW_CASE_PARAM } from "../../consts";

const GT_PATH = "/mietrechtsanfragen";

/**
 * Top bar: names the current page and carries the primary action.
 * Search, theme and account all live in the sidebar, so nothing is
 * duplicated here.
 */
export const Topbar = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const title = getPageTitle(pathname);

  // The list view only - not an individual case, which has its own actions.
  const showCreateCase =
    pathname === GT_PATH && !new URLSearchParams(search).has("id");

  return (
    <Toolbar
      sx={{
        minHeight: APPBAR_HEIGHT,
        height: APPBAR_HEIGHT,
        px: { xs: 2, sm: 3 },
      }}
    >
      <Box
        sx={{
          minWidth: 0,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          component="h1"
          sx={{
            fontSize: "0.9375rem",
            fontWeight: 600,
            color: "text.primary",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {title}
        </Typography>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
            "&:empty": { display: "none" },
          }}
        >
          <HeaderBreadcrumbs />
        </Box>
      </Box>

      <Box sx={{ flexGrow: 1 }} />

      {/* Only on the Mietrechtsanfragen list - that is the one case type
          an admin creates by hand. The dialog itself stays inside that
          route because it needs its CaseProvider, so we ask it to open
          via a query param rather than rendering it here. */}
      {showCreateCase && (
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate(`${GT_PATH}?${NEW_CASE_PARAM}=1`)}
        >
          Fall anlegen
        </Button>
      )}
    </Toolbar>
  );
};

export default Topbar;
